import { Injectable } from '@angular/core';
import { GetParticipantConfirmationStatementService } from '@modules/api/get-participant-confirmation-statement.service.generated';
import { b64toBlob } from '@modules/common/functions/b64-to-blob';
import { downloadBlob } from '@modules/common/functions/download-blob';
import { SnackbarService } from '@modules/common/services/snackbar.service';

/**
 * Service to download a confirmation statement.
 */
@Injectable({
    providedIn: 'root'
})
export class DownloadParticipantConfirmationStatementService {
    constructor(
        private _getParticipantConfirmationStatementService: GetParticipantConfirmationStatementService,
        private _snackbarService: SnackbarService
    ) { }

    /**
     * Download the given confirmation statement
     * @param documentId The ID of the confirmation statement to download
     */
    public downloadParticipantConfirmationStatement(documentId: string): void {
        this._getParticipantConfirmationStatementService.getParticipantConfirmationStatement({
            documentId: documentId
        }).subscribe(data => {
            if (data.fileData && data.fileData.length && data.contentType) {
                let b = b64toBlob(data.fileData, data.contentType);
                downloadBlob(b, data.fileName);
            } else {
                this._snackbarService.open({ message: "File Not Found!" });
            }
        });
    }
}
